@if (item.isRoot || item.rowType === 'root-process') {
  <div class="process-info-container">
    <app-resource-status [item]="item" [resourceType]="'process-execution'"></app-resource-status>
    @if (item.isRoot || showToggle) {
      <div class="info-details-container" id="RowInfo_{{ item.id }}">
        <div class="duration-container">
          <div class="clock-icon"></div>
          <div class="duration-summary">{{ fromNow }}{{ duration }}</div>
        </div>
        <div class="status-container">
          <div class="status-summary">
            {{ status }}
            @if (item.warning) {
              <div>{{ item.warning }}</div>
            }
          </div>
        </div>
      </div>
    }
  </div>
}
@if (item.rowType === 'step-header') {
  <div
    [ngClass]="{ 'parallel-step': item.isParallel }"
    class="step-header-container"
    id="RowInfo_{{ item.id }}"
    >
    <div class="step-label header-label">
      {{ item.isParallel ? 'Name' : 'Step' }}
    </div>
    <div class="started-label header-label">Started</div>
    <div class="finished-label header-label">Finished</div>
    <div class="duration-label header-label">Duration</div>
    <div class="state-label header-label">State</div>
  </div>
}
@if (!item.isRoot && (item.rowType === 'sub-process' || item.rowType === 'parallel-step')) {
  <div
    [ngClass]="{ 'parallel-step': item.isParallel }"
    class="step-header-container"
    id="RowInfo_{{ item.id }}"
    >
    <div class="step-label step-content">
      <app-resource-status [item]="item" [resourceType]="'process-execution'"></app-resource-status>
      <div class="sub-process-image"></div>
    </div>
    <div class="started-label step-content">
      {{ startedLabel }}
    </div>
    <div class="finished-label step-content">
      {{ finishedLabel }}
    </div>
    <div class="duration-label step-content">
      {{ duration }}
    </div>
    <div class="state-label step-content">
      {{ state }}
    </div>
  </div>
}
